









































import { Component, Vue } from 'vue-property-decorator';
import Avatar from '@/components/Avatar.vue';
import ContextMenu from '@/components/ContextMenu.vue';

@Component({ components: { Avatar, ContextMenu } })
export default class UserMenu extends Vue {
  get user() {
    return this.$store.getters['user/user'];
  }

  async logout() {
    await this.$store.dispatch('app/logout');
    this.$store.dispatch('courses/resetState');
    this.$router.push({ path: 'login' });
  }
}
